import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { UserService } from 'services/user.service';
import { ApplicationService } from 'services/application.service';
import { AlertService } from 'services/alert.service';
import swal from 'sweetalert2';


@Component({
  selector: 'app-updatewifidetails',
  templateUrl: './updatewifidetails.component.html',
  styleUrls: ['./updatewifidetails.component.scss']
})
export class UpdatewifidetailsComponent implements OnInit {
  form: FormGroup;
  srcApplicationList: any[];
  applicationList: any[];
  dropdownSettings = {};
  wifiCredential = {};
  showCredential = false;
  showNewPassword = false;
  fieldTextType: boolean;

  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private applicationService: ApplicationService,
    private alertService: AlertService) {
    this.initializeValidators();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'Un Select All',
      itemsShowLimit: 4,
      allowSearchFilter: true
    };
  }

  ngOnInit() {
    this.getApplicationList(false);
  }

  getApplicationList(refresh) {
    this.userService.getApplicationList(refresh).subscribe(result => {
      this.srcApplicationList = [];
      this.applicationList = [];
      this.srcApplicationList = result;
      var keyValue = 0;

      this.srcApplicationList.forEach(applicationItem => {
        if (applicationItem.vumatelNetworkIdentifier) {
          this.applicationList.push({ key: keyValue, value: applicationItem.referenceNumber });
          keyValue = keyValue + 1;
        }
      });
    });
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      application: ['', [Validators.required]],
      newpassword: ['', [Validators.required, Validators.maxLength(35), Validators.minLength(8)]],
    });
  }
  // email: ['', [Validators.required, Validators.email]],
  //   password: ['', [Validators.required, PasswordStrengthValidator, Validators.maxLength(12), Validators.minLength(8)]],
  //   confirmpassword: ['', [Validators.required]],
  changePassword() {
    if (this.form.value.application.value) {
      this.showNewPassword = true;
    }
    else {
      this.showNewPassword = false;
      this.alertService.warning('Please Select Application');
    }
  }

  updatePassword() {
    // if(this.form.value.newpassword && this.form.value.application.value)
    if (this.form.valid) {
      var postData = {
        referenceNumber: this.form.value.application.value,
        newPassword: this.form.value.newpassword
      };

      this.applicationService.updateWifiCredentialWithReference(postData).subscribe(response => {
        if (response && response.result && response.result.wifi_username && response.result.wifi_password) {
          this.wifiCredential = response;
          this.showCredential = false;
          this.showNewPassword = false;
          swal.fire({
            title: 'Updated successfully',
            // text: "Username: "+ response.result.wifi_username +". "+"Password: "+ response.result.wifi_password +".",            
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Ok',
          }).then((res) => {
            if (res.value) {
              this.ngOnInit();
            }
          });
          // this.alertService.success('Updated successfully!');
          // this.ngOnInit();
        }
        else {
          this.showCredential = true;
          swal.fire({
            title: 'Oops! Something went wrong',
            text: "Unable to Update. Please Try again later!",
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Ok',
          }).then((res) => {
            if (res.value) {
            }
          });
          //this.alertService.warning('Unable to Update. Please Try again later!');
        }
      });
    }
    else {
      // if(!this.form.value.application.value && !this.form.value.newpassword){
      //   this.alertService.warning('Please select Application and enter new Password to Update');
      // }
      // else if(!this.form.value.application.value){
      //   this.alertService.warning('Please select Application');
      // }
      // else if(!this.form.value.newpassword){
      //   this.alertService.warning('Please enter new Password to Update');
      // }
      this.validateFormControl();
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
}
